/**
 * Character GLB URLs only — safe for prewarm without PlayerRig / TrophyMesh.
 */

/** Default player (locker / tunnel / aim idle + walk). */
export const PLAYER_KICK_GLB_URL = '/model/player_kicking_ball.glb?v=kick2';

/** Penalty strike after aim — Captain Tsubasa Mixamo kick. */
export const CAPTAIN_TSUBASA_GLB_URL = '/model/captain_tsubasa.glb';

export const TROPHY_GLB_URL = '/model/trophy.glb';
